var convert = require('./convert'),
    func = convert('isLength', require('../isLength'), require('./_falseOptions'));

func.placeholder = require('./placeholder');
module.exports = func;
